export const enum AnnualReportListMenuActions {
    ARCHIVE = 'archive',
    RESTORE = 'restore',
    DELETE = 'delete',
    DISPLAY_ACTIVE = 'display_active',
    DISPLAY_ARCHIVED = 'display_archived',
}
